var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.886 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "whatsapp 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.057,24l1.687-6.163a11.89179,11.89179,0,1,1,4.618,4.509Zm6.597-3.807a9.8614,9.8614,0,1,0-2.743-2.667l-.999,3.648Zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941,1.165s-.347.223-.644.074a8.11051,8.11051,0,0,1-2.39-1.475,8.94541,8.94541,0,0,1-1.653-2.059c-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521a1.94926,1.94926,0,0,0,.3-.495.54633.54633,0,0,0-.025-.521c-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01a1.08871,1.08871,0,0,0-.792.372,3.33442,3.33442,0,0,0-1.04,2.479A5.78287,5.78287,0,0,0,7.22,12.325a13.249,13.249,0,0,0,5.076,4.487,17.19446,17.19446,0,0,0,1.694.626,4.08451,4.08451,0,0,0,1.872.118,3.06084,3.06084,0,0,0,2.006-1.413A2.47566,2.47566,0,0,0,18.041,14.729Z",
    transform: "translate(-0.057)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIc);
export default __webpack_public_path__ + "static/media/whatsapp-ic.01d976bbdac7467695ead2331f747c52.svg";
export { ForwardRef as ReactComponent };